<main>
    <div class="app app-margin" [dir]="textDir">
        <div class="app-container-pm">
            <section class="nav-area" [ngClass]="loginInfo.role.name=='GeneralAdmin'?'nav-80':'nav-116'">             
                <div class="row top-section padT15">
                    <div class="md-12 lg-12 xl-12">
                        <section class="breadcrmb">
                            <a [routerLink]="['/']" >{{'Home' | translate}}</a>  <span class="eds-sep">&nbsp;/&nbsp;</span>
                            <ng-container *ngIf="this.projectData?.name">
                            <a [routerLink]="['/projectmanagement']" >{{'Project management' | translate}}</a>  <span class="eds-sep">&nbsp;/&nbsp;</span>
                            <a [routerLink]="['/projectmanagement', this.project_id, 'view']"  >{{this.projectData?.name}}</a>  <span class="eds-sep">&nbsp;/&nbsp;</span>
                            </ng-container>
                            <ng-container *ngIf="!this.projectData?.name">
                            <a [routerLink]="['/schoolmanagement']" >{{'School Management' | translate}}</a>  <span class="eds-sep">&nbsp;/&nbsp;</span>
                            </ng-container>
                            <span class="active" *ngIf=this.school_id>{{'Edit School' | translate}}</span>
                            <span class="active" *ngIf=!this.school_id>{{'Add a new school' | translate}}</span>
                        </section>
                    </div>
                </div>
                <div class="row top-section">
                   <!--  <div class="lg-3">
                        <h4></h4>
                    </div> -->
                    <div class="lg-6 marT5">
                        <label class="title-18">{{'Add a new school' | translate}}</label>
                    </div>
                    <div class="lg-3">
                        <h4>&nbsp;</h4>
                    </div>
                </div>            
            </section>
            <div class="app-container marT30" [dir]="textDir">
                <div class="row top-section">
                    <div class="lg-3 wiz-pos marT20 padT3" >
                        <!-- Steps panle in left start-->
                        <app-ctl-wizard-steps
                          [ctlSteps]=this.wizardSteps
                          [activestep]=currentSteps></app-ctl-wizard-steps>
                        <!-- Steps panle in left end-->
                    </div>
                    <div class="s-form-wid">
                            <div *ngIf="currentSteps < 3">
                              <app-ctl-school-form *ngIf="currentSteps==1"
                                  [project_id]="project_id"
                                  [projectName]="projectName"
                                  [countryName]="countryName" 
                                  [myFormGroup]="curSchoolForm"
                                  (schoolFormChange)="formChange(true)"
                                  [mySchoolCategoryList]="schoolCategoryList"
                                  [myCountry]="country"
                                  [viewType]="'add'"
                                  [myRegionList]="regionList"></app-ctl-school-form>
                                  
                               <app-ctl-user-form *ngIf="currentSteps==2"
                                  [myFormGroup]="curUserForm"
                                  [myrole]="'SchoolAdmin'"
                                  [projName]="projectName"
                                  [myCountry]="country"
                                  (userFormChange)="formChange(true)"></app-ctl-user-form>  

                            </div>
                              <app-ctl-school-detail *ngIf="currentSteps==3" [projectName]="projectName" [myFormGroup]="curSchoolForm" [userData]=userData [data]=schoolData (editSchool)="editLink('school')" (editAdmin)="editLink('admin')"></app-ctl-school-detail>  
                       <div *ngIf="step" class="white-bg" >
                          <hr>
                          <div class="spaceBtwn padT10">
                            <!-- <a [routerLink]="['/projectmanagement',project_id,'view']" class="btn btn-link">Cancel </a>
                             -->
                            <div>
                                <button (click)='cancelSchool()' class="btn btn-ghost">{{'Cancel' | translate}} </button>
                            </div> 

                            <div>
                                <button (click)='backStep()' *ngIf="(currentSteps ==2 )" class="btn btn-back" [ngClass]="textDir=='rtl'?'marL10':'marR10'"><i class="icon icon-arrow-left"></i>{{'Back' | translate}}</button>
                                <button (click)='backStep()' *ngIf="(currentSteps == 3)" class="btn btn-back" [ngClass]="textDir=='rtl'?'marL10':'marR10'"><i class="icon icon-arrow-left"></i>{{'Edit' | translate}}</button> 

                                <button *ngIf="(currentSteps==1 && this.btnnext == false )" [disabled]="(currentSteps==1 && this.btnnext == false )" class="btn disabled primary">{{'Next' | translate}} <i class="icon icon-arrow-right padL5"></i></button>
                                <button (click)='nextStep()' *ngIf=" (currentSteps==1 && this.btnnext == true)" class="btn primary">{{'Next' | translate}} <i class="icon icon-arrow-right padL5"></i> </button>
                                <button *ngIf=" (currentSteps==2 && this.btnnext == false)" class="btn primary" [disabled]="(currentSteps==2 && this.btnnext == false )">{{'Review' | translate}} <i class="icon icon-arrow-right padL5"></i> </button>
                                <button (click)='nextStep()' *ngIf=" (currentSteps==2 && this.btnnext == true)" class="btn primary">{{'Review' | translate}} <i class="icon icon-arrow-right padL5"></i> </button>

                                <button [disabled]="clicked" (click)='finalStep(); clicked = true;' *ngIf="currentSteps==3" class="btn primary" >{{'Complete' | translate}} </button>
                            </div>

                          </div>
                    </div>                      
                         
                    </div>
          
                    <div class="flexStart info-txt marT20 marB20 marL280" [dir]="textDir" ><i class="icon icon-info marT3"></i> <label class="labeltxt" [ngClass]="textDir=='rtl'?'padR5':'padL5'">{{'School details can be edited' | translate}}</label></div>
                </div>
            </div>
        </div>
    </div>
</main>
